import DashboardRepository from "./DashboardRepository";
import _ from "lodash";
import moment from 'moment'

class DashboardService {
    constructor() {
        this.dashboard = new DashboardRepository();

    }

    stages = {
        'Completed': {class: 'bg-success', text: 'Completed'},
        'Failed': {class: 'bg-danger', text: 'Failed'},
        'In Progress': {class: 'bg-primary', text: 'In Progress'},
        'In Waiting': {class: 'bg-warning', text: 'In Waiting'},
        'In Delay': {class: 'bg-warning', text: 'In Waiting'},
        'In-progress': {class: 'bg-primary', text: 'In Progress'},
    };

    getButton = (key) => {

        try {
            let button = this.stages[key] ? this.stages[key] : key;

            return button ? `<span class="stage btn btn-xs text-white ${button.class}">${button.text}</span>` : key;
        } catch (error) {
            console.error(error)
            return key
        }
    }


    getFailedButton = (key) => `<span class="stage btn btn-xs text-white bg-danger">${key}</span>`

    getTimeDiff = (start, end) => {
        // Create two Date objects representing the two times
        const startTime = new Date(start); // Replace with your start time
        const endTime = new Date(end); // Replace with your end time

        // Calculate the time difference in milliseconds
        const timeDifferenceInMilliseconds = endTime - startTime;

        // Convert the time difference to minutes
        const timeDifferenceInMinutes = timeDifferenceInMilliseconds / (1000 * 60);


        return Math.round(Math.floor(timeDifferenceInMinutes));

    }

    getPerformance = (data) => {
        const PERFORMANCE_KEY = "queue_performance_cache";
        const PERFORMANCE_TS = "queue_performance_cache_ts";
        const MAX_KEYS = 1000;
        const RESET_INTERVAL = 15 * 60 * 1000; // 15 minutes
        const TOTAL_TIME = " total time";

        if (typeof localStorage === "undefined") {
            console.error("localStorage not available");
            return {};
        }

        const now = Date.now();

        // --- Check and reset performance if 15 min passed ---
        const lastTs = Number(localStorage.getItem(PERFORMANCE_TS) || 0);

        if (!lastTs || now - lastTs >= RESET_INTERVAL) {
            localStorage.setItem(PERFORMANCE_KEY, JSON.stringify({}));
            localStorage.setItem(PERFORMANCE_TS, String(now));
        }

        // Load after possible reset
        let performance = {};
        try {
            performance = JSON.parse(localStorage.getItem(PERFORMANCE_KEY) || "{}");
        } catch {
            performance = {};
        }

        // --- Your existing logic ---
        for (const record of data) {
            const recordKey = record.fileId;
            if (!recordKey) {
                console.warn("Skipping record without key:", record);
                continue;
            }

            const totalTimeQueues = Object.keys(record).filter(k => k.endsWith(TOTAL_TIME));

            for (let queue of totalTimeQueues) {
                const queueName = queue.replace(TOTAL_TIME, "");
                const timeValue = Number(record[queue] ?? 0);

                if (!performance[queueName]) {
                    performance[queueName] = {
                        totalTime: 0,
                        count: 0,
                        processedKeys: []
                    };
                }

                const queuePerf = performance[queueName];

                if (queuePerf.processedKeys.includes(recordKey)) {
                    continue;
                }

                queuePerf.totalTime += timeValue;
                queuePerf.count += 1;
                queuePerf.processedKeys.push(recordKey);

                if (queuePerf.processedKeys.length > MAX_KEYS) {
                    queuePerf.processedKeys.splice(0, queuePerf.processedKeys.length - MAX_KEYS);
                }
            }
        }

        localStorage.setItem(PERFORMANCE_KEY, JSON.stringify(performance));
        return performance;
    };


    setList = (data) => {
        let secondPerPage = 0;
        let records = [];
        for (const record of data) {
            let diffTime;
            if (record.redisLastUpdate) {
                diffTime = this.getTimeDiff(record.redisLastUpdate, new Date());
            }

            let batchId = record.batchId;
            try {
                let fileCreateTime = record.file_create_time;
                const client = `${record.client_name ? record.client_name + '-' : ''}${record.client_id ? record.client_id : '-'}`;
                const FAILED_TIME = ' fail time';
                const COMPLETED_TIME = ' complete time';
                const completedStages = Object.keys(record).filter(key => key.endsWith(COMPLETED_TIME));
                const failedStages = Object.keys(record).filter(key => key.endsWith(FAILED_TIME));

                const failed_at = [];
                for (let stage of failedStages) {
                    if(!record[stage]) continue;
                    const queueName = stage.replace(FAILED_TIME, '');
                    const isAlreadyCompleted = completedStages.find(item => item.includes(queueName));
                    if (isAlreadyCompleted) continue;
                    if (!record.current_stage.includes(queueName)) failed_at.push(queueName);
                }

                let status = record.status;
                const isDelay = record.current_stage.includes('ocr_fetch_data') &&
                    status === 'Failed' &&
                    record.error_message?.includes('running');
                if (isDelay) {
                    status = 'In Delay';
                }

                status = this.getButton(status);


                let row = {
                    id: record.key || '-',
                    source: record.source || '-',
                    feed_id: parseInt(record.feed_id) || '-',
                    filename: record.filename || '-',
                    current_stage: record.current_stage || '-',
                    batchId: batchId?.substring(0, 18) || '-',
                    status: status,
                    failed_stages: failed_at.map(stage => this.getFailedButton(stage)) || '-',
                    client: client?.substring(0, 13) || '-',
                    apiCentreLink: ``,
                    feedSettingLink: ``,
                    updateBefore: `${diffTime} min ago`,
                    readyToDelete: record?.autoDeleteMessage ?? 'No',
                    fileId: Number(record.fileId),
                    mccDetailIdUploadId: `${Number(record.mccDetailId) || Number(record.uploadId) || '-'}`,
                    fileCreateTime: fileCreateTime && moment(fileCreateTime).isValid() ? moment(fileCreateTime).format('DD-MM-YYYY hh:mm:ss A') : 'N/A',
                    isAllDone: record.isAllDone,
                    // moment(record.file_create_time).tz('Asia/Kolkata').format('DD-MM-YYYY hh:mm:ss A')
                };


                if (record.start_time) {
                    row.start_time = moment(record.start_time).format('DD-MM-YYYY hh:mm:ss A')
                } else {
                    row.start_time = 'N/A';
                }


                if (record.end_time) {

                    row.end_time = moment(record.end_time).format('DD-MM-YYYY hh:mm:ss A')
                } else {
                    row.end_time = 'N/A';
                }

                let r = {};

                Object.keys(row).map(k => {
                    row[k] = (['filename', 'start_time', 'end_time'].includes(k) && diffTime !== undefined && diffTime <= 10 && typeof row[k] !== "object") ? `<b>${row[k]}</b>` : row[k]
                })

                // if (record.isAllDone) {
                //     record.isAllDone = `<span class="isAllDone">${row[k]}</span>`;
                // }

                if(record?.isAllDone) {
                    row.isAllDone = record?.isAllDone ?`<b class="isAllDone">Yes</b>`: 'No';
                }else{

                    row.isAllDone = (row?.status === 'Failed' || failed_at.length) ?`<b class="somethingFailed">No</b>`: 'No';

                }

                records.push(row);
            } catch (e) {
                console.error(e, record);
            }


        }
        window.fpSpeed = secondPerPage;
        return records;
    }

    remove = async ({id, data}) => {
        await this.dashboard.remove(id);

        return _.remove(data, function (currentObject) {
            return currentObject.id === id;
        });
    }

    showData = async (data, {getState}) => {
        let {id} = data;
        return this.dashboard.showData(id);
    }


    retry = async (row) => {
        return this.dashboard.retry(row);
    }

    reprocess = async (data) => {
        let ids = data.id.split(",");
        for (let id of ids) {
            data.id = id;
            await this.dashboard.reprocess(data);
        }
    }


    hasError = async ({id}) => {
        return this.dashboard.hasError(id);
    }

    isHistoryView = () => {
        const searchParams = new URLSearchParams(window.location.search);
        const view = searchParams.get("view");

        return view === 'history';
    }

    list = async (state, params1) => {
        try {
            let {currentPage, pageLimit, selectedFlow, selectedClient} = state;

            let params = {currentPage, pageLimit, filter: {
                    flow: selectedFlow ?? '',
                    clientId: selectedClient ?? '',
                }};


            let {result: listResponse, totalRecords} = await this.dashboard.getData({...params});
            let data = _.filter(listResponse, (obj) => (state?.filteredStage?.length === 0 || state?.filteredStage?.includes(obj.current_step)));
            data = this.setList(data);


            data = _.filter(data, function (obj) {
                for (let columnName in state.filterData) {
                    if ((obj[columnName]).toString().toLowerCase().indexOf((state.filterData[columnName]).toString().toLowerCase()) === -1) {
                        return false;
                    }
                }
                return true;
            }.bind(this));
            const performance = this.getPerformance(listResponse);
            return {listResponse, data, totalRecords, performance};
        } catch (error) {
            console.error(error);
            return {data: [], totalRecords: 0};
        }

    };

    updateData = async (data) => {
        data = JSON.parse(data);

        return this.dashboard.updateData(data);
    }

    getPerformanceData = async (data) => {
        return this.dashboard.getPerformanceData(data);
    }

    getClientList = async (data) => {
        const result = await this.dashboard.getClientList(data);
        return Object.entries(result).reduce((clients, [clientId, value]) => {
            clients.push({id:clientId,name:value});
            return clients;
        }, []);
    }
}

export default DashboardService;
